"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isPlainObject(obj) {
    return obj
        ? typeof obj === 'object' && Object.getPrototypeOf(obj) === Object.prototype
        : false;
}
var supportType = [
    'string',
    'number',
    'array',
    'object',
    'boolean',
    'integer',
];
function getType(type) {
    if (!type)
        type = 'string';
    if (supportType.includes(type)) {
        return type;
    }
    return typeof type;
}
function isSchema(object) {
    if (supportType.includes(object.type)) {
        return true;
    }
    return false;
}
function handleSchema(json, jsonSchema) {
    Object.assign(jsonSchema, json);
    if (jsonSchema.type === 'object') {
        delete jsonSchema.schema;
        parse(json.schema, jsonSchema);
    }
    if (jsonSchema.type === 'array') {
        delete jsonSchema.schema;
        jsonSchema.schema = {};
        parse(json.schema, jsonSchema.schema);
    }
}
function handleArray(arr, jsonSchema) {
    jsonSchema.type = 'array';
    jsonSchema.schema = {};
    for (var key in arr[0]) {
        jsonSchema.schema[key] = {};
        parse(arr[0][key], jsonSchema.schema[key]);
    }
}
function handleObject(json, jsonSchema) {
    if (isSchema(json)) {
        return handleSchema(json, jsonSchema);
    }
    jsonSchema.type = 'object';
    jsonSchema.schema = {};
    for (var key in json) {
        var item = json[key];
        jsonSchema.schema[key] = {};
        parse(item, jsonSchema.schema[key]);
    }
}
function parse(json, jsonSchema) {
    if (Array.isArray(json)) {
        handleArray(json, jsonSchema);
    }
    else if (isPlainObject(json)) {
        handleObject(json, jsonSchema);
    }
    else {
        jsonSchema.type = getType(json);
    }
    return jsonSchema;
}
function jsonToSchema(data) {
    var JsonSchema = parse(data, {});
    return JsonSchema;
}
exports.default = jsonToSchema;
